import type { LscArchiveItem } from '../../types';

/** Sources after the lead. The server already ordered them. */
export function otherBroadcasts(archive: LscArchiveItem): LscArchiveItem[] {
  const sources = archive.sources;
  if (!sources || sources.length < 2) return [];
  return sources.slice(1);
}

export function otherBroadcastLabel(others: LscArchiveItem[], source: LscArchiveItem): string {
  if (others.length === 1) return 'Watch the other broadcast';
  const login = (source.provider_broadcaster_login || '').trim();
  return login ? `Watch @${login}` : 'Watch the other broadcast';
}
